import React, { useCallback, useEffect, useState } from "react";
import { Sidebar } from "./sidebar";
import { Header } from "./header";
import { MobileNav } from "./mobile-nav";
import { CommandPalette } from "./command-palette";
import { DashboardChromeContext } from "./dashboard-chrome";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const openPalette = useCallback(() => setPaletteOpen(true), []);

  // Global ⌘K / Ctrl-K to summon the command palette from anywhere.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <DashboardChromeContext.Provider value={{ openPalette }}>
      <div className="min-h-screen bg-[#FFFBFB] text-[#3a2e2c]">
        <Sidebar />
        <MobileNav />

        <div className="lg:pl-[264px]">
          <Header />
          {/* Bottom padding on mobile clears the fixed tab bar. */}
          <main className="px-4 pb-24 pt-4 sm:px-6 lg:px-8 lg:pb-10 lg:pt-6">{children}</main>
        </div>

        <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
      </div>
    </DashboardChromeContext.Provider>
  );
};

export default DashboardLayout;
